// built in libs
import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// shared libs
import { SelectizeComponent, Options } from '../../blocks';

// services
import { CountryService } from './countries/country.service';
import { Country } from './countries/country';
import { CityService } from './cities/city.service';
import { City } from './cities/city';
import { VillageService } from './villages/village.service';
import { Village } from './villages/village';
import { GovService } from './govs/gov.service';
import { Gov } from './govs/gov';
import { FullAddress } from './fulladdress';
import { UserSessionService } from '../../shared';
import { LoaderService } from '../../ng2-loader/loader.service';

@Component({
    selector: 'address-component',
    templateUrl: './address.component.html'
})


export class AddressComponent implements OnInit {

    @Input() smallInput: boolean = true;
    @Input() public tabindex: number = 19;


    ///********************************************** model fields *****************************************
    ngCountryId: number;
    ngGovId: number;
    ngCityId: number;
    ngVillageId: number;
    ngNatId: number;
    // --------------------------------------------------------------------------------------------------------
    currentcountry: Country;
    currentgov: Gov;
    currentcity: City;
    currentvillage: Village;
    addressForm: UntypedFormGroup;

    @Output() private countryIdEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private govIdEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private cityIdEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private villageIdEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private nationalityIdEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private mobileEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private fullAddressArEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private fullAddressEnEmitted: EventEmitter<any> = new EventEmitter();
    // ---------------------------------------------------------------------------------------------------------------------/

    @Input() private fullAddress: FullAddress;
    @Input() public settingObj: any;
    @Input() public FromHrEmployeesRegistration : boolean;
    defaultUserBranch: number;


    // ---------------------------------------------------------------------------------------------------------------------/

    constructor(
        private loaderService: LoaderService,
        private fb: UntypedFormBuilder,
        private _countryService: CountryService,
        private _govService: GovService,
        private _cityService: CityService,
        private _villageService: VillageService,
        public translate: TranslateService,
        private _userSessionService: UserSessionService,) {


        this.fullAddress = <FullAddress>{};

    }
    // ---------------------------------------------------------------------------------------------------------------------/
    ngOnInit() {

       
       
        this.addressForm = this.fb.group({
            countryCode: null,
            countryNameEn: '',
            countryNameAr: '',

            govCode: '',
            govNameEn: '',
            govNameAr: '',

            cityCode: '',
            cityNameEn: '',
            cityNameAr: '',

            villageCode: '',
            villageNameEn: '',
            villageNameAr: '',

            nationalityId: null,
            nationalityNameEn: '',
            nationalityNameAr: '',
            mobile: '',

            floorNo: '',
            buildingNumber: '',
            neighborhood:'',

            fullAddressAr: { value: '', disabled: false },
            fullAddressEn: { value: '', disabled: false }
        }); 

        this.setHrJsonSettings('employee')

        if (this.settingObj == undefined) {

            this.settingObj = {
                "address.countryCode": {
                    "display": true
                },
                "address.govCode": {
                    "display": true
                }, 
                "address.villageCode": {
                    "display": true
                }
            }
        }


    }

    stepsObj: any
    setHrJsonSettings(settingFileName: string, folder?: string) {
        this.defaultUserBranch = 1
        this.loaderService.getSettings(`${settingFileName}_${this.defaultUserBranch == undefined ? 1 : this.defaultUserBranch}`
            , folder).subscribe(
                 
                v => {
                    this.settingObj = v
                    console.log(' this.stepsObj_____', this.settingObj)
                },
                error => console.log(error),
                () => { }
            );
    }
    getHrJsonObj() {
        console.log(this.stepsObj)
        return this.stepsObj
    }

    // ***************************** country selectize eare ***************************************************************
    @ViewChild('countrySelectize') selectizeCountry: SelectizeComponent;
    ///////////////Issue...... in filter and initialize data in selectize....... ibrahim
    onCountryClicked(selectedItem: any): void {
        if (selectedItem) {
            if (selectedItem['AutoEmited']) {
                return;
            }
            let natId = this.addressForm.get('nationalityId').value;
            natId = natId || selectedItem.countryCode;
            // ==================================================== holde data to use again=============================/////////////
            this.addressForm.patchValue({
                countryCode: selectedItem.countryCode,
                countryNameAr: selectedItem.nameAr, countryNameEn: selectedItem.nameEn,
                nationalityId: natId
            });
            // ********************************* #Gouhar set govs  ***************************************************************
            // this.selectizeGov.clear();
            // this.selectizeGov.clearItems();
            // ********************************* #Gouhar set city  ***************************************************************
            this.selectizeCity.clear();
            this.selectizeCity.clearItems();
            // ********************************* #Gouhar set village ***************************************************************
            this.selectizeVillage.clear();
            this.selectizeVillage.clearItems();
            this.selectizeGov.setFastSearchKey('ParentId', selectedItem.countryCode);
            // if (!selectedItem['AutoEmited']) {
            // ===================================================== clear data from form control===========================////////
            this.addressForm.get('govCode').setValue('')
            this.addressForm.get('govNameAr').setValue('')
            this.addressForm.get('govNameEn').setValue('')
            this.addressForm.get('cityCode').setValue('')
            this.addressForm.get('cityNameAr').setValue('')
            this.addressForm.get('cityNameEn').setValue('')
            this.addressForm.get('villageCode').setValue('')
            this.addressForm.get('villageNameAr').setValue('')
            this.addressForm.get('villageNameEn').setValue('')
            this.addressForm.get('mobile').setValue('')

            // ===================================================== clear data from selectize===========================////////
            //this.addressForm.patchValue({ fullAddressAr: this.makeFullAddressAr() });
            // this.addressForm.patchValue({ fullAddressEn: this.makeFullAddressEn() });
            // ********************************* #Gouhar set govs  ***************************************************************
            // this.selectizeGov.clear();
            // this.selectizeGov.clearItems();
            // // ********************************* #Gouhar set city  ***************************************************************
            // this.selectizeCity.clear();
            // this.selectizeCity.clearItems();
            // // ********************************* #Gouhar set village ***************************************************************
            // this.selectizeVillage.clear();
            // this.selectizeVillage.clearItems();
            // }
            // this._userSessionService.setSessionKey('SelectedCounterycode',selectedItem );
        }
    }
    // ---------------------------------------------------------------------------------------------------------------------/


    // ********************************* #Gouhar ***************************************************************

    // ********************************** gov selectize area ***************************************************************
    // govList: Gov[] = [];
    selectizeVillageOptions: Options;
    @ViewChild('govSelectize') selectizeGov: SelectizeComponent = new SelectizeComponent;


    onGovClicked(selectedItem: any): void {

        // holde data to use again && !selectedItem['AutoEmited']

        if (selectedItem) {
            if (selectedItem['AutoEmited']) {
                return;
            }
            //   this.addressForm.patchValue({ govCode: selectedItem.code, govNameAr: selectedItem.nameAr, govNameEn: selectedItem.nameEn });
            // this.addressForm.get('govCode').setValue(selectedItem.code)
            this.addressForm.get('govNameAr').setValue(selectedItem.nameAr)
            this.addressForm.get('govNameEn').setValue(selectedItem.nameEn)
            this.currentgov = selectedItem;
            this.selectizeCity.clear();
            this.selectizeCity.clearItems();
            this.selectizeVillage.clear();
            this.selectizeVillage.clearItems();

            this.selectizeCity.setFastSearchKey('ParentId', selectedItem.code);
            // if (selectedItem['AutoEmited']) {
            this.selectizeCity.toggleDropdown = false;
            this.selectizeVillage.toggleDropdown = false;

            this.addressForm.get('cityCode').setValue('')
            this.addressForm.get('cityNameAr').setValue('')
            this.addressForm.get('cityNameEn').setValue('')
            this.addressForm.get('villageCode').setValue('')
            this.addressForm.get('villageNameAr').setValue('')
            this.addressForm.get('villageNameEn').setValue('')

            //this.addressForm.patchValue({ fullAddressAr: this.makeFullAddressAr() });
            //this.addressForm.patchValue({ fullAddressEn: this.makeFullAddressEn() });
            // this.selectizeCity.clear();
            // this.selectizeCity.clearItems();
            // this.selectizeVillage.clear();
            // this.selectizeVillage.clearItems();

            // ********************************* #Gouhar set village ***************************************************************

            // }
        }

    }
    // ---------------------------------------------------------------------------------------------------------------------/



    // ********************************* #Gouhar ***************************************************************
    // ********************************* city selectize area ***************************************************************
    // cityList: City[] = [];
    selectizeCityOptions: Options;
    @ViewChild('citySelectize') selectizeCity: SelectizeComponent;


    onCityClicked(selectedItem: any): void {
        // holde data to use again
        if (selectedItem) {
         //   this.addressForm.patchValue({ cityCode: selectedItem.code, cityNameAr: selectedItem.nameAr, cityNameEn: selectedItem.nameEn });
            this.addressForm.patchValue({ cityCode: selectedItem.code});
            this.currentcity = selectedItem;
            if( this.selectizeVillage){
                this.selectizeVillage.clear();
                this.selectizeVillage.clearItems();
                this.selectizeVillage.setFastSearchKey('ParentId', selectedItem.code);
            }
        
            // if (selectedItem['AutoEmited']) {
            this.addressForm.get('villageCode').setValue('')
            this.addressForm.get('villageNameAr').setValue('')
            this.addressForm.get('villageNameEn').setValue('')
            //this.addressForm.patchValue({ fullAddressAr: this.makeFullAddressAr() });
            //this.addressForm.patchValue({ fullAddressEn: this.makeFullAddressEn() });
            // this.selectizeVillage.clear();
            // this.selectizeVillage.clearItems();
            // }

        }
    }
    //  ---------------------------------------------------------------------------------------------------------------------/



    // ********************************* village selectize area ***************************************************************
    // villageList: Village[] = [];
    selectizeGovOptions: Options;
    @ViewChild('villageSelectize') selectizeVillage: SelectizeComponent;
    onVillageClicked(selectedItem: any): void {
        if (selectedItem) {
            // holde data to use again
            this.addressForm.patchValue({
                villageCode: selectedItem.code
                , villageNameAr: selectedItem.nameAr, villageNameEn: selectedItem.nameEn
            });
            // this.ngVillageId = selectedItem != null ? selectedItem.code : undefined;
            this.currentvillage = selectedItem;
            //this.addressForm.patchValue({ fullAddressAr: this.makeFullAddressAr() });
            //this.addressForm.patchValue({ fullAddressEn: this.makeFullAddressEn() });
        }
    }
    // ---------------------------------------------------------------------------------------------------------------------/



    // ********************************* nationallty selectize area ***************************************************************
    // natList: Country[] = [];
    selectizeNationalityOptions: Options;
    @ViewChild('nationalitySelectize') selectizeNat: SelectizeComponent = new SelectizeComponent;



    onNatClicked(selectedItem: any): void {
        if (selectedItem) {
            this.ngNatId = selectedItem.code;
            this.addressForm.patchValue({ nationalityId: selectedItem.code });
        }
    }

    // ---------------------------------------------------------------------------------------------------------------------/
    // ---------------------------------------------------------------------------------------------------------------------/
    /**

     * used to update value in address form group
     * @param IAddress object
     */
    updateFormGroup(address: any) {

        this.addressForm.patchValue({
            countryCode: address.countryCode,
            countryNameEn: address.countryNameEn,
            countryNameAr: address.countryNameAr,

            govCode: address.govCode,
            govNameEn: address.govNameEn,
            govNameAr: address.govNameAr,

            cityCode: address.cityCode,
            cityNameEn: address.cityNameEn,
            cityNameAr: address.cityNameAr,

            villageCode: address.villageCode,
            villageNameEn: address.villageNameEn,
            villageNameAr: address.villageNameAr,

            nationalityId: address.nationalityId,
            mobile: address.mobile,

            nationalityNameEn: address.nationalityNameEn,
            nationalityNameAr: address.nationalityNameAr,

            fullAddressAr: address.addressAr, // `${address.countryNameAr} ${address.govNameAr} ${address.cityNameAr}  ${address.villageNameAr}`,
            fullAddressEn: address.addressEn //`${address.countryNameEn} ${address.govNameEn}  ${address.cityNameEn}  ${address.villageNameEn}`,
        });
        this.selectizeCountry.setFormControl(address.countryNameAr, address.countryNameEn);
        this.selectizeGov.setFormControl(address.govNameAr, address.govNameEn);
      //  this.selectizeCity.setFormControl(address.cityNameAr, address.cityNameEn);
        this.selectizeVillage.setFormControl(address.villageNameAr, address.villageNameEn);
        this.selectizeNat.setFormControl(address.nationalityNameAr, address.nationalityNameEn);
    }


    // used by passing an model object to get address properties from it  and return  new object of  IAddress
    getAddressObjFromModel(MVobj: any): IAddress {

        const _address = <IAddress>{};
        _address.countryCode = MVobj.countryCode,
            _address.countryNameEn = MVobj.countryNameEn;
        _address.countryNameAr = MVobj.countryNameAr;

        _address.govCode = MVobj.govCode;
        _address.govNameEn = MVobj.govNameEn;
        _address.govNameAr = MVobj.govNameAr;

        _address.cityCode = MVobj.cityCode;
        _address.cityNameEn = MVobj.cityNameEn;
        _address.cityNameAr = MVobj.cityNameAr;

        _address.villageCode = MVobj.villageCode;
        _address.villageNameEn = MVobj.villageNameEn;
        _address.villageNameAr = MVobj.villageNameAr;

        _address.floorNo = MVobj.floorNo;
        _address.buildingNumber = MVobj.buildingNumber;
        _address.neighborhood = MVobj.neighborhood;

    
        _address.nationalityId = MVobj.nationalityId;
        _address.mobile = MVobj.mobile;

        _address.nationalityNameEn = MVobj.nationalityNameEn;
        _address.nationalityNameAr = MVobj.nationalityNameAr;

        MVobj.countryNameAr = MVobj.countryNameAr == null ? '' : MVobj.countryNameAr;
        MVobj.govNameAr = MVobj.govNameAr == null ? '' : MVobj.govNameAr;
        MVobj.cityNameAr = MVobj.cityNameAr == null ? '' : MVobj.cityNameAr;
        MVobj.villageNameAr = MVobj.villageNameAr == null ? '' : MVobj.villageNameAr;

        MVobj.countryNameEn = MVobj.countryNameEn == null ? '' : MVobj.countryNameEn;
        MVobj.govNameEn = MVobj.govNameEn == null ? '' : MVobj.govNameEn;
        MVobj.cityNameEn = MVobj.cityNameEn == null ? '' : MVobj.cityNameEn;
        MVobj.villageNameEn = MVobj.villageNameEn == null ? '' : MVobj.villageNameEn;


        if (MVobj.addressAr == '' || MVobj.addressAr == undefined) {

            _address.fullAddressAr = `${MVobj.countryNameAr} ${MVobj.govNameAr}  ${MVobj.cityNameAr}  ${MVobj.villageNameAr}`;
            _address.fullAddressEn = `${MVobj.countryNameEn} ${MVobj.govNameEn}  ${MVobj.cityNameEn}  ${MVobj.villageNameEn}`;


        }
        else {
            _address.fullAddressAr = MVobj.addressAr;
            _address.fullAddressEn = MVobj.addressEn;
            this.fullAddress = MVobj.addressAr
        }
        return _address;
    }


    /**
     * used to update control of address form only one form control
     * @param name of form control which updated
     * @param new value from form control
     */
    updateFormControl(name: string, value: any) {
        this.addressForm.patchValue({ name: value });
    }

    /**
     * return address form group
     */
    getAddressForm(): UntypedFormGroup {
        return this.addressForm;
    }



    makeFullAddressAr(): string {
        const c = this.addressForm.get('countryNameAr').value as UntypedFormControl
            != undefined ? this.addressForm.get('countryNameAr').value as UntypedFormControl : ' ';
        const g = this.addressForm.get('govNameAr').value as UntypedFormControl
            != undefined ? this.addressForm.get('govNameAr').value as UntypedFormControl : ' ';
        const t = this.addressForm.get('cityNameAr').value as UntypedFormControl
            ? this.addressForm.get('cityNameAr').value as UntypedFormControl : ' ';
        const v = this.addressForm.get('villageNameAr').value as UntypedFormControl
            ? this.addressForm.get('villageNameAr').value as UntypedFormControl : ' ';

        return `${c}   ${g}   ${t}   ${v}`;

    }
    makeFullAddressEn(): string {
        const c = this.addressForm.get('countryNameEn').value as UntypedFormControl != undefined
            ? this.addressForm.get('countryNameEn').value as UntypedFormControl : ' ';
        const g = this.addressForm.get('govNameEn').value as UntypedFormControl != undefined
            ? this.addressForm.get('govNameEn').value as UntypedFormControl : ' ';
        const t = this.addressForm.get('cityNameEn').value as UntypedFormControl
            ? this.addressForm.get('cityNameEn').value as UntypedFormControl : ' ';
        const v = this.addressForm.get('villageNameEn').value as UntypedFormControl
            ? this.addressForm.get('villageNameEn').value as UntypedFormControl : ' ';

        return `${c}  ${g}  ${t}  ${v}`;
    }

    // ---------------------------------------------------------------------------------------------------------------------/

}


export interface IAddress {
    countryCode: number;
    countryNameEn: string;
    countryNameAr: string;

    govCode: number;
    govNameEn: string;
    govNameAr: string;

    cityCode: number;
    cityNameEn: string;
    cityNameAr: string;

    villageCode: number;
    villageNameEn: string;
    villageNameAr: string;

    nationalityId: number;
    mobile: string;
    nationalityNameEn: string;
    nationalityNameAr: string;

    fullAddressAr: string;
    fullAddressEn: string;

    floorNo:  number;
    buildingNumber:  number;
    neighborhood: string
}
